import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const BREADCRUMB_SEPARATOR_CLASS_NAME = 'Breadcrumb';
export const BREADCRUMB_SEPARATOR_CLASS_SLOTS = ['root'] as const;

export type BreadcrumbSeparatorClassSlot =
	(typeof BREADCRUMB_SEPARATOR_CLASS_SLOTS)[number];

export interface BreadcrumbSeparatorClasses {
	root: string;
}

export type BreadcrumbSeparatorClassKey = keyof BreadcrumbSeparatorClasses;

export const getBreadcrumbSeparatorUtilityClass = (slot: string) =>
	generateUtilityClass(BREADCRUMB_SEPARATOR_CLASS_NAME, slot);

export const breadcrumbSeparatorClasses: BreadcrumbSeparatorClasses =
	generateUtilityClasses(BREADCRUMB_SEPARATOR_CLASS_NAME, ['root']);

export default breadcrumbSeparatorClasses;
